import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-charcoal text-gray-400 py-8 px-6 text-center text-sm" data-id="element-91">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-3" data-id="element-92">
          <div className="flex items-center gap-4" data-id="element-93">
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-94">
              Términos y Condiciones
            </button>
            <span className="text-gray-600" data-id="element-95">•</span>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-96">
              Política de Privacidad
            </button>
          </div>
          <p className="text-gray-500" data-id="element-97">
            © {new Date().getFullYear()} Protocolo Calma 3 Minutos. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-98">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-99">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-white rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-100">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200 sticky top-0 bg-white z-10" data-id="element-101">
                <h2 className="text-xl font-bold text-brand-charcoal" data-id="element-102">
                  {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-103">
                  <X className="w-5 h-5 text-gray-500" data-id="element-104" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-gray-700 leading-relaxed text-sm space-y-6" data-id="element-105">
                {activeModal === 'terms' ? <TermsContent data-id="element-106" /> : <PrivacyContent data-id="element-107" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gray-500 italic" data-id="element-108">Última actualización: mayo 2026</p>

      <div data-id="element-109">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-110">
          1. Aceptación de los términos
        </h3>
        <p data-id="element-111">
          Al realizar la compra del Protocolo Calma 3 Minutos, aceptas estos
          términos y condiciones en su totalidad. Si no estás de acuerdo con
          alguno de estos términos, te pedimos que no realices la compra.
        </p>
      </div>

      <div data-id="element-112">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-113">
          2. Producto digital
        </h3>
        <p data-id="element-114">
          El Protocolo Calma 3 Minutos es un producto digital en formato PDF. Al
          completar tu compra, recibirás acceso inmediato para descargar el
          material. Este producto es para uso personal y no puede ser
          redistribuido, revendido ni compartido públicamente.
        </p>
      </div>

      <div data-id="element-115">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-116">3. Precio y pago</h3>
        <p data-id="element-117">
          El precio indicado en la página de venta es el precio vigente al
          momento de la compra. Los precios pueden cambiar sin previo aviso. El
          pago se procesa de forma segura a través de la plataforma de pago
          correspondiente.
        </p>
      </div>

      <div data-id="element-118">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-119">
          4. Garantía de devolución
        </h3>
        <p data-id="element-120">
          Ofrecemos una garantía de devolución de 7 días desde la fecha de
          compra. Si no estás satisfecho con el producto, puedes solicitar un
          reembolso completo dentro de ese plazo sin necesidad de justificación.
          Las solicitudes de reembolso fuera de este período no serán aceptadas.
        </p>
      </div>

      <div data-id="element-121">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-122">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-123">
          Todo el contenido del Protocolo Calma 3 Minutos, incluyendo textos,
          gráficos, diseños y metodologías, está protegido por derechos de
          autor. Queda prohibida su reproducción, distribución o modificación
          sin autorización expresa.
        </p>
      </div>

      <div data-id="element-124">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-125">
          6. Limitación de responsabilidad
        </h3>
        <p data-id="element-126">
          Este producto tiene fines educativos e informativos. No sustituye la
          orientación de un profesional de la salud mental o del desarrollo
          infantil. Los resultados pueden variar según cada familia y situación
          particular. No nos hacemos responsables del uso que se le dé al
          contenido.
        </p>
      </div>

      <div data-id="element-127">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-128">
          7. Modificaciones
        </h3>
        <p data-id="element-129">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor desde su publicación en
          esta página.
        </p>
      </div>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-gray-500 italic" data-id="element-130">Última actualización: mayo 2026</p>

      <div data-id="element-131">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-132">
          1. Información que recopilamos
        </h3>
        <p data-id="element-133">
          Al realizar una compra, recopilamos únicamente la información
          necesaria para procesar tu pedido: nombre, dirección de correo
          electrónico y datos de pago. No almacenamos datos de tarjetas de
          crédito directamente; estos son procesados de forma segura por nuestro
          proveedor de pagos.
        </p>
      </div>

      <div data-id="element-134">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-135">
          2. Uso de la información
        </h3>
        <p data-id="element-136">Utilizamos tu información personal exclusivamente para:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-137">
          <li data-id="element-138">Procesar y entregar tu compra</li>
          <li data-id="element-139">Enviar el enlace de descarga del producto</li>
          <li data-id="element-140">Gestionar solicitudes de soporte o devolución</li>
          <li data-id="element-141">Enviar comunicaciones relacionadas con tu compra</li>
        </ul>
      </div>

      <div data-id="element-142">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-143">
          3. Protección de datos
        </h3>
        <p data-id="element-144">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración.
        </p>
      </div>

      <div data-id="element-145">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-146">
          4. Compartición de datos
        </h3>
        <p data-id="element-147">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cumplir
          con obligaciones legales.
        </p>
      </div>

      <div data-id="element-148">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-149">5. Cookies</h3>
        <p data-id="element-150">
          Podemos utilizar cookies y tecnologías similares para mejorar la
          experiencia de navegación y analizar el tráfico del sitio. Puedes
          configurar tu navegador para rechazar cookies, aunque esto podría
          afectar algunas funcionalidades.
        </p>
      </div>

      <div data-id="element-151">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-152">6. Tus derechos</h3>
        <p data-id="element-153">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. También puedes solicitar la limitación del
          tratamiento de tus datos o ejercer tu derecho de portabilidad.
        </p>
      </div>

      <div data-id="element-154">
        <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-155">
          7. Cambios en esta política
        </h3>
        <p data-id="element-156">
          Nos reservamos el derecho de actualizar esta política de privacidad.
          Cualquier cambio será publicado en esta página con la fecha de
          actualización correspondiente.
        </p>
      </div>
    </>;
}